var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrencyLine = function SvgCurrencyLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.5 15.6h1.8V4.8h-9v1.8h7.2zm0 1.8v2.7c0 .497-.405.9-.906.9H4.806a.9.9 0 0 1-.906-.9l.003-12.6c0-.497.405-.9.906-.9H7.5V3.9a.9.9 0 0 1 .9-.9h10.8a.9.9 0 0 1 .9.9v12.6a.9.9 0 0 1-.9.9zm-10.797-9L5.7 19.2h9V8.4zM7.5 15.6h4.05a.45.45 0 1 0 0-.9h-2.7a2.25 2.25 0 0 1 0-4.5h.45v-.9h1.8v.9h1.8V12H8.85a.45.45 0 1 0 0 .9h2.7a2.25 2.25 0 1 1 0 4.5h-.45v.9H9.3v-.9H7.5z"
  })));
};
export default SvgCurrencyLine;